import React from 'react';
import { Button, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
const BusinessUnitItem = _ref => {
  var _pbu$business_unit;
  let {
    pbu,
    handleDelete,
    pageAccess
  } = _ref;
  const businessUnitName = ((_pbu$business_unit = pbu.business_unit) === null || _pbu$business_unit === void 0 ? void 0 : _pbu$business_unit.name) || 'no_name';
  const isLongName = businessUnitName.length > 50;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: isLongName ? /*#__PURE__*/React.createElement(Tooltip, null, businessUnitName) : /*#__PURE__*/React.createElement("div", null)
  }, /*#__PURE__*/React.createElement(Badge, {
    pill: true,
    className: "text-dark",
    bg: "body"
  }, isLongName ? businessUnitName.substring(0, 50) + '...' : businessUnitName, pageAccess.canEditProjectDetails && /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    className: "p-1 d-inline-flex ms-1",
    onClick: () => handleDelete(pbu.id)
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 text-warning"
  }, "delete")))));
};
export default BusinessUnitItem;